import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../hooks/useAuth';

const UserMenu = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  if (!user) return null;

  const [firstName, ...rest] = user.name.split(' ');
  const lastName = rest.join(' ');

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex h-8 items-center whitespace-nowrap rounded-md bg-neutral-100 px-3 text-sm text-neutral-800 hover:bg-neutral-200"
      >
        <span className="font-bold">{firstName}</span>
        {lastName && <span className="font-medium text-neutral-600">&nbsp;{lastName}</span>}
      </button>

      {open && (
        <div className="absolute right-0 top-full z-30 mt-2 w-56 rounded-md border border-neutral-200 bg-white py-1 shadow-md">
          <p className="truncate border-b border-neutral-100 px-3 py-2 text-xs text-neutral-500">{user.email}</p>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              logout();
            }}
            className="block w-full px-3 py-2 text-left text-sm text-neutral-700 hover:bg-neutral-50"
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
